import { vars } from "@common/styles";
import { rgba } from "polished";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

import { HelperText } from "../../../../../../common/components/HelperText/HelperText";
import CustomInput from "../../../../../../common/components/Input/Input";
import Paragraph from "../../../../../../common/components/Paragraph/Paragraph";
import BaseSelectDropdown from "../../../../../../common/components/SelectDropdown/SelectDropdown";
import { Flex as BaseFlex } from "../../../../../../common/styles/reusable/Flex/Flex.styles";

export const Input = styled(CustomInput)`
  padding-bottom: 2.4rem;
`;

export const HeadingSubtitle = styled(Paragraph)`
  display: inline-block;
`;

export const LinkText = styled(Link)`
  margin-bottom: 0;
`;

export const ButtonNote = styled(Paragraph)`
  display: flex;
  align-items: center;
  margin-left: 2.4rem;
`;

export const SelectDropdown = styled(BaseSelectDropdown)`
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
`;

export const Flex = styled(BaseFlex)`
  padding-top: 0.8rem;
`;

export const Helper = styled(HelperText)<{ $noMargin?: boolean }>`
  margin-bottom: 0.8rem;
  ${(props) =>
    !props.$noMargin &&
    css`
      margin-bottom: 2.4rem;
    `}
`;

export const FreeAndUnlimitedNote = styled.div`
  border-radius: 16px;
  padding: 1px 6px 3px;
  background-color: ${rgba(vars.colors.green, 0.2)};

  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: ${vars.colors.green};
`;
